import { colors, devices, font } from '../../../config/theme'
import {
  asPx,
  width100,
  hidden,
  pointer,
  flexCenter,
  marginPadding0,
  flexRowSpaceBetween,
  flexColSpaceBetween,
  scrollY
} from '../../../utils/jss-utils'

const style = {}

const timeSlotHeight = 65

style.base = {
  maxWidth: '100%',
  ...scrollY,
  '& div': {
    '& ul': {
      ...marginPadding0,
      '& li': {
        ...pointer,
        transition: 'all .2s',
        border: `1px solid ${colors.blue}`,
        color: colors.black,
        ...flexCenter,
        height: `${asPx(timeSlotHeight)}`,
        fontSize: '21px',
        margin: '18px 0 18px 0'
      }
    }
  }
}

style.datesWrapper = {
  ...width100,
  marginBottom: '50px'
}

style.carotContainer = {
  ...flexCenter,
  maxWidth: '50px',
  minWidth: '50px'
}

style.carot = {
  height: '70px !important',
  width: '50px !important',
  transition: 'all .2s',
  ...flexCenter,
  '& img': {
    width: '10px'
  },
  '&:hover': {
    cursor: 'pointer',
    opacity: 0.4
  }
}

style.monthCarot = {
  ...flexCenter,
  maxWidth: '60px',
  minWidth: '60px',
  transition: 'all .2s',
  '&:hover': {
    cursor: 'pointer',
    opacity: 0.4
  },
  '& img': {
    marginTop: '5px',
    height: '13px'
  }
}

style.monthName = {
  ...flexCenter,
  fontWeight: font.weights.medium,
  fontSize: '24px',
  margin: '0 !important'
}

style.monthWrapper = {
  display: 'flex',
  justifyContent: 'center',
  width: '100%'
}

style.dayCard = {
  width: '22%',
  display: 'inline-block',
  margin: '20px 1.75% 20px 1.75%'
}
style.dayTitle = {
  ...flexRowSpaceBetween,
  margin: '15px 0 35px 0',
  '& span:first-child': {
    paddingRight: '8px'
  },
  fontWeight: font.weights.medium,
  fontSize: '16px',
  paddingTop: '10px',
  borderTop: `1px solid ${colors.lightGray}`
}
style.hideOnMobile = {}
style.hideOnDesktop = {}

style.isActiveTime = {
  // height: `${asPx(timeSlotHeight - activeBorderWidth - 2)} !important`, //-1 for some reason
  // border: `${asPx(activeBorderWidth)} solid ${colors.blue} !important`
  backgroundColor: colors.blue,
  color: `${colors.white} !important`
}

style.isDisabledTime = {
  color: `${colors.lighterGray} !important`,
  cursor: 'not-allowed !important',
  border: `1px solid ${colors.lighterGray} !important`
}

style.isUpcomingTime = {
  color: `${colors.white} !important`,
  cursor: 'default !important',
  border: `1px solid #C1C1C1 !important`,
  backgroundColor: `#C1C1C1 !important`
}

style.hideOnMobile[devices.mobile] = { ...hidden }
style.hideOnDesktop[devices.desktop] = { ...hidden }

style.dayCard[devices.mobile] = {
  width: '95%',
  display: 'block !important',
  padding: '0 10px',
  backgroundColor: '#F4F4F4',
  '& ul': {
    display: 'flex',
    flexWrap: 'wrap'
  },
  '& li': {
    width: '45%',
    margin: '2% !important'
  }
}

style.cardsWrapper = {
  '& .no-appointments': {
    margin: '50px'
  }
}

style.cardsWrapper[devices.desktop] = {
  ...flexRowSpaceBetween
}

style.carot[devices.mobile] = {
  ...hidden
}
style.base[devices.mobile] = {
  backgroundColor: '#F4F4F4'
}

// style.datesWrapper[devices.mobile] = {
//   height: '100%'
// }

style.monthWrapper[devices.mobile] = {
  borderTop: `1px solid ${colors.lighterGray}`,
  borderBottom: `1px solid ${colors.lighterGray}`,
  boxShadow: `0px 5px 5px ${colors.lighterGray}`,
  backgroundColor: colors.white,
  padding: '15px 0 15px 0',
  justifyContent: 'space-between',
  height: '61px !important'
}

style.cardsWrapper[devices.mobile] = {
  ...flexColSpaceBetween,
  backgroundColor: '#F4F4F4'
}

// style.dayDesktop[devices.mobile] = { ...width100 }

export default style
